/*
 * Get A Query Variable
 *
 * Simple url string parsing function to grab
 * a query variable or return false if not set
 */
PayaraAjax.getQueryVariable = function(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { 
            return pair[1];
        }
    }
    return(false);
}


/*
 * Check If ANY Query Variables
 *
 * Lorem ipsum dolor sit amet, consectetur adipiscing
 * elit. Proin aliquam commodo quam etiamx imperdiet.
 */
PayaraAjax.hasQueryVars = function() {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    return vars.length >= 1;
}


/*
 * Remove A Query Variable
 *
 * Lorem ipsum dolor sit amet, consectetur adipiscing
 * elit. Proin aliquam commodo quam etiamx imperdiet.
 */
PayaraAjax.removeQueryVariable = function(variable) {
    window.history.pushState(null, null, window.location.pathname);
}


/**
 * Helper function to find closest ancestor
 * (polyfill as closest is not supported by IE11)
 * 
 * @param el DOM node to find the ancestor for
 * @param selector Query selector string
 * @return {HTMLElement | {matchesSelector}}
 */
PayaraAjax.findAncestor = function(el, selector) {
    while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el, selector)));
    return el;
}


/**
 * Helper function to replicate jQuery trigger
 * 
 * For a full list of event types: https://developer.mozilla.org/en-US/docs/Web/API/Event
 * 
 * @param el DOM node to trigger
 * @param eventType Type of event to trigger
 */
PayaraAjax.trigger = function(el, eventType) {
    if (typeof eventType === 'string' && typeof el[eventType] === 'function') {
        el[eventType]();
    } else {
        const event =
            typeof eventType === 'string'
            ? new Event(eventType, {bubbles: true})
            : eventType;
        el.dispatchEvent(event);
    }
}
